import {Form, Input, Modal, Select} from "antd";
import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../../core/models/custom/enums/modalType";
import {FormValuesContactUs} from "../../../../core/models/custom/formValuesContactUs";
import {ModalVisibilityPayload} from "../../../../core/models/custom/modalVisibility.payload";
import {ContactRequest} from "../../../../core/models/requests/contact.request";
import {contact} from "../../../../core/services/contactService/contact/actions";
import {ContactState} from "../../../../core/services/contactService/contact/types";
import ContentKeys from "../../../../core/utilities/contentKeys";
import {Images} from "../../../../core/utilities/images";
import {IStore} from "../../../../core/utilities/reducers";
import {UI} from "../../../../core/utilities/ui";
import AppButton from "../../../Buttons/AppButton/AppButton";
import ContentKey from "../../../ContentKey/ContentKey";
import ModalCancelButton from "../../Common/ModalCancelButton/ModalCancelButton";
import ModalHeader from "../../Common/ModalHeader/ModalHeader";
import "./ContactUsModal.scss";

const {Option} = Select;

interface IProps {
  modalVisibilityData: ModalType[];
  contents: Map<string, string>;
  contactState: ContactState;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
  contact: (request: ContactRequest) => void;
}

interface IState {
  isSent: boolean;
  isError: boolean;
}

class ContactUsModal extends React.Component<IProps> {
  state: IState = {
    isSent: false,
    isError: false,
  }
  
  private readonly modal = ModalType.DRAWER_CONTACT_US;
  private readonly errorText = "Bir hata oluştu. Lütfen tekrar deneyin!";
  
  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.contactState.loading && !this.props.contactState.loading) {
      if (this.props.contactState.data) {
        this.setState({isSent: true});
      } else if (this.props.contactState.error) {
        this.setState({isError: true});
      }
    }
  }
  
  private isVisible(): boolean {
    return this.props.modalVisibilityData.includes(this.modal);
  }
  
  private getSubjects(): string[] {
    const subjectsString = this.props.contents.get(ContentKeys.CONTACT_SUBJECTS);
    let subjects: string[] = [];
    if (subjectsString) {
      subjects = subjectsString.split("|");
    }
    return subjects;
  }
  
  private handleModalClose(): void {
    this.props.setModalVisibility({modal: this.modal, isVisible: false});
  }
  
  private handleFinish(values: FormValuesContactUs): void {
    this.setState({isError: false});
    this.props.contact({...values})
  }
  
  private renderForm = (): ReactNode => {
    return (
      <Form
        id="contact-us-form"
        className="mid-content"
        layout="vertical"
        onFinish={values => this.handleFinish(values)}
      >
        <Form.Item
          className="form-item"
          name="email"
          label={<ContentKey contentKey={ContentKeys.CONTACT_MAIL_TITLE}/>}
          required={false}
          rules={[
            {required: true, message: ''},
            {type: "email", message: ''},
          ]}
        >
          <Input
            className="form-input"
            type="email"
            placeholder={this.props.contents.get(ContentKeys.CONTACT_MAIL_PH)}
          />
        </Form.Item>
        
        <Form.Item
          className="form-item"
          name="subject"
          label={<ContentKey contentKey={ContentKeys.CONTACT_SUBJECT_TITLE}/>}
          required={false}
          rules={[
            {required: true, message: ''},
          ]}
        >
          <Select
            className="form-input select"
            placeholder={this.props.contents.get(ContentKeys.CONTACT_SUBJECT_PH)}
          >
            {this.getSubjects().map(subject => {
              return <Option key={subject} value={subject}>{subject}</Option>;
            })}
          </Select>
        </Form.Item>
        
        <Form.Item
          className="form-item"
          name="body"
          label={<ContentKey contentKey={ContentKeys.CONTACT_MESSAGE_TITLE}/>}
          required={false}
          rules={[
            {required: true, message: ''},
          ]}
        >
          <Input
            className="form-input"
            type="text"
            placeholder={this.props.contents.get(ContentKeys.CONTACT_MESSAGE_PH)}
          />
        </Form.Item>
        
        {this.state.isError && <p className="error-text">{this.errorText}</p>}
        
        <div className="button-wrapper">
          <AppButton
            isFormSubmit={true}
            text={<ContentKey contentKey={ContentKeys.CONTACT_BUTTON}/>}
            disabled={this.props.contactState.loading}
            onClick={() => {
            }}
          />
        </div>
      </Form>
    );
  }
  
  private renderSent = (): ReactNode => {
    return (
      <div
        id="contact-us-success"
        className="mid-content"
      >
        <img className="icon" src={Images.popup_icon_checkmark} alt="icon"/>
        <ContentKey
          className="text"
          contentKey={ContentKeys.CONTACT_SUCCESFUL_MESSAGE}
        />
        <AppButton
          text={<ContentKey contentKey={ContentKeys.CONTACT_SUCCESFUL_BUTTON}/>}
          onClick={() => this.handleModalClose()}
        />
      </div>
    );
  }
  
  render() {
    return (
      <Modal
        className="contact-us-modal"
        maskStyle={UI.modalMaskStyle()}
        open={this.isVisible()}
        closable={false}
        footer={false}
        centered
        destroyOnClose
      >
        <ModalHeader
          className="drawer-modal"
          text={<ContentKey contentKey={ContentKeys.CONTACT_POPUP_TITLE}/>}
          icon={<img className="icon" src={Images.drawer_popup_header_faq} alt="icon"/>}
        />
        <div className="body">
          {this.state.isSent
            ? this.renderSent()
            : this.renderForm()
          }
        </div>
        {!this.state.isSent && <ModalCancelButton callback={() => this.handleModalClose()}/>}
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
      contact,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    modalVisibilityData: store.setModalVisibility.data,
    contents: store.getContents.data,
    contactState: store.contact,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsModal);
